import React from "react";
import { Link } from "react-router-dom";
import ImageCarousel from "./ImageCarousel";

function ProductCard({ product }) {
  return (
    <div className="product-card">
      <div className="card-carousel">
        {product.images && product.images.length > 0 ? (
          <ImageCarousel images={product.images} productName={product.name} />
        ) : (
          <div className="carousel-placeholder"></div>
        )}
      </div>
      <div className="product-card-info">
        <h2>{product.name}</h2>
        <p>${product.price}</p>
        <p className={product.inStock ? "in-stock" : "out-of-stock"}>
          {product.inStock ? "In Stock" : "Out of Stock"}
        </p>
      </div>
      <Link to={`/product/${product.id}`} className="details-btn">
        View
      </Link>
    </div>
  );
}

export default ProductCard;
